package com.exura.features.plandefinition.data.remote.dto.series

import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for SimpleFloatingSeries.
 * Extends BaseSeriesDto directly (not BaseAnchoredSeriesDto).
 */
@Serializable
@SerialName("floating_series")
data class SimpleFloatingSeriesDto(
    override val name: String,
    override val description: String,
    override val seriesType: SeriesSpawnType = SeriesSpawnType.FLOATING,
    override val durationInDays: Int = 0,
    val instruction: String,
    val estimatedMinutes: Int,
    val deadline: Int? = null,
    val exactTime: HourOfDay? = null,
    override val imageUrl: String? = null
) : BaseSeriesDto()
